import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontLeftDoorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontLeftDoor(props: FrontLeftDoorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Front Left Door"
      width={330}
      height={115}
      viewBox="0 0 330 115"
      position={{bottom: -28, left: 409}}
    >
      {/* Door body + glass (evenodd composite) */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M328 1L309 52.6953C309.333 54.8086 309 60.7671 305 67.6953C301 74.6235 297.333 82.8867 296 86H1C1 79.0248 6.18307 60.5778 26 54C27.7022 53.435 30 53 33 52C54 45 177.033 9 233 5C257.055 3.28073 281.035 1.26803 298 1H328ZM308.704 7C219.704 7 186 17 135 30C119.545 33.9396 105 38 97 42C93.0738 43.9631 87.0339 48.9719 82.042 53.958C140.06 54.5106 232.001 53 283 53C293.406 34.9622 299.615 23.5601 308.704 7Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Door glass overlay */}
      <path
        opacity="0.8"
        d="M308.704 7C299.614 23.5601 293.406 34.9622 283 53C232 53 140.059 54.5111 82.0416 53.9585C87.0336 48.9721 93.0736 43.9632 97 42C105 38 119.545 33.9396 135 30C186 17 219.704 7 308.704 7Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Outer stroke */}
      <path
        d="M233 5C177.033 9 54 45 33 52C30 53 27.7022 53.435 26 54C6.18307 60.5778 1 79.0244 1 85.9996L296 86C297.333 82.8867 301 74.6235 305 67.6953C309 60.7671 309.333 54.8086 309 52.6953L328 1H298C281.035 1.26803 257.055 3.28073 233 5Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Pillar line */}
      <path
        d="M283 53C294.616 32.8664 301 21 312 1"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Glass inner line */}
      <path
        d="M82 54C87 49 93.0627 43.9686 97 42C105 38 119.545 33.9396 135 30C186 17 220 7 309 7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Belt line */}
      <path
        d="M9 66.4783C86.604 65.962 194.989 65.6405 307 64.3913L9 66.4783Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Waist line */}
      <path
        d="M33 52C58 56 211.141 53 283 53H309"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Mirror body fill */}
      <path
        d="M33 52C40.3544 53.1767 58.7983 53.7803 83 54L82.2148 54.7949C80.3359 56.7419 78.2682 59.3527 79.9795 61.9668C86.4304 60.9884 93.1867 60.7034 97.2373 61.3389C103.669 62.3479 111.308 110.143 108.34 112.161C105.371 114.179 95.2576 117.841 79.4258 101.698C74.0279 96.1943 69.8557 90.7988 67.0664 85.876L67 86C65.1795 82.7047 60 73.6 56 68C52 62.4 39 55 33 52Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Mirror outline */}
      <path
        d="M79.4258 101.698C95.2582 117.841 105.372 114.179 108.34 112.161C111.309 110.143 103.669 62.3483 97.2373 61.3392C90.8053 60.3302 77.5511 61.6401 69.5305 64.3661C57.6562 68.402 62.5747 84.5157 79.4258 101.698Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Mirror inner line */}
      <path
        d="M91 61C96 66 104 95 104 113"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Mirror arm */}
      <path
        d="M67 86C65.1795 82.7047 60 73.6 56 68C52 62.4 39 55 33 52C40.3544 53.1767 58.7983 53.7803 83 54C81 56 78 59 80 62"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Door handle fill */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M245 76C259.937 76.0003 279.853 78 277.861 81C271.119 91.1562 252.966 91 245 91C237.034 91 218.881 91.1562 212.139 81C210.147 78 230.062 76.0003 245 76ZM228 82C229.766 84.2432 232.491 86 237 86H253C257.509 86 260.234 84.2432 262 82H228Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Handle outline */}
      <path
        d="M277.862 81C271.119 91.1563 252.966 90.9999 245 90.9999C237.034 90.9999 218.881 91.1563 212.138 81C210.147 78 230.062 76.0003 245 76C259.937 76.0003 279.853 78 277.862 81Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Handle inner */}
      <path
        d="M264 77C263.667 79.6667 261 86 253 86C245 86 245 86 245 86C245 86 245 86 237 86C229 86 226.333 79.6667 226 77"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M228 82H262"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
